import { Component, EventEmitter, Output, Input, ChangeDetectorRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { PrimeNGSharedModule } from "@shared/prime/prime-ng.module";

@Component({
  selector: "app-user-role",
  templateUrl: "./user-role.component.html",
  styleUrls: ["./user-role.component.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, PrimeNGSharedModule],
})
export class UserRoleComponent {
  roles = [
    "Super Admin",
    "Admin - Regional TAC",
    "Authorised Dealers/Distributor",
    "Field Service Engineer",
    "Customer External Admin",
    "Cyber Authorised personnel",
    "BioMedical Engineer",
    "Global Service engineer",
  ];

  constructor(private cdr: ChangeDetectorRef) {}

  selectedRole: string | null = null;
  @Input() visible: boolean = true;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeDialog = new EventEmitter<void>();
  @Output() roleSelected = new EventEmitter<string>();

  selectRole(role: string): void {
    this.selectedRole = role;
    this.cdr.detectChanges();
  }

  onContinue(): void {
    localStorage.removeItem("userDetails");
    localStorage.removeItem("addProductLineDetails");
    localStorage.removeItem("customerDetails");
    localStorage.removeItem("selectedInjectors");
    localStorage.removeItem("trainingExpiryDate");
    if (this.selectedRole) {
      this.roleSelected.emit(this.selectedRole);
    }
  }

  onClose(): void {
    this.closeDialog.emit();
    this.cdr.detectChanges();
  }
}
